module.exports = __webpack_public_path__ + "static/media/NIVEL_RIESGO_F3.ca88d270.svg";